
<script>
import { defineComponent } from 'vue'
import { contactName } from '@kit/utils/Formats'

export default defineComponent({
  props: ["contact", "showName"],
  name: "ContactInfo",
  setup() {
    return { contactName }
  }
});
</script>

<style scoped>

.white-heart {
  left:auto;
  width:30px;
  right:10px; 
  top:10px;
}

</style>

<template>

  <article class="info-box sb sb-v sb-gr sb-greedy-1">
    <h3 v-if="showName" class="sb" style="margin-bottom:10px;">{{contactName(contact)}}</h3>
    <h3 class="sb">Contact Info</h3>
    <div class="sb-abox white-heart">
      <img src="@images/STHS-WeCare-logo_white-heart.png" style="object-fit:contain; width:100%; height:auto;"/>
    </div>
    <ul class="sb sb-greedy sb-v sb-align-cv sb-gr" style="padding:0px; font-size:1.2em">
      <li v-if="contact.phone_number" class="sb sb-h sb-greedy-1">
        <b class="sb sb-explicit" style="width:50px;">Phone: </b>
        <span class="sb sb-greedy sb-text" style="text-align:right;">{{contact.phone_number}}</span>
      </li>
      <li v-if="contact.fax_number" class="sb sb-h sb-greedy-1">
        <b class="sb sb-explicit" style="width:50px;">Fax: </b>
        <span class="sb sb-greedy sb-text" style="text-align:right;">{{contact.fax_number}}</span>
      </li>
      <li v-if="contact.email" class="sb sb-h sb-greedy-1">
        <b class="sb sb-explicit" style="width:50px;">Email: </b>
        <span class="sb sb-greedy sb-text" style="text-align:right;">{{contact.email}}</span>
      </li>
    </ul>
  </article>

</template>

